import Vue from 'vue'

const KyeAutocomplete = Vue.component('kye-autocomplete', {
  functional: true,
  render (h, self) {
    return h('el-autocomplete', self.data, self.children)
  }
})

export default KyeAutocomplete



// WEBPACK FOOTER //
// ./src/public/components/kye-autocomplete/index.js